var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSurveyIconDeveloper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.125.75H1.875C.891.75.125 1.543.125 2.5v7.875c0 .984.766 1.75 1.75 1.75h4.047l-.274 1.313H4.281c-.383 0-.656.3-.656.656 0 .383.273.656.656.656h7.438a.648.648 0 0 0 .656-.656c0-.356-.3-.656-.656-.656h-1.395l-.273-1.313h4.074c.957 0 1.75-.766 1.75-1.75V2.5c0-.957-.793-1.75-1.75-1.75zM6.988 13.438l.274-1.313H8.71l.273 1.313H6.988zm7.574-3.063a.45.45 0 0 1-.437.438H1.875a.432.432 0 0 1-.438-.438V2.5a.45.45 0 0 1 .438-.438h12.25a.47.47 0 0 1 .438.438v7.875zm-4.539-5.852a.62.62 0 0 0-.793 0 .62.62 0 0 0 0 .793l.93.93-.93.902a.62.62 0 0 0 0 .793c.11.11.247.137.41.137a.512.512 0 0 0 .383-.137l1.313-1.312a.62.62 0 0 0 0-.793l-1.313-1.313zm-3.28 0a.62.62 0 0 0-.794 0L4.637 5.836a.62.62 0 0 0 0 .793L5.949 7.94c.11.11.246.137.41.137a.512.512 0 0 0 .383-.137.62.62 0 0 0 0-.793l-.93-.93.93-.902a.62.62 0 0 0 0-.793z",
    fill: "#233145"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveyIconDeveloper);
export default __webpack_public_path__ + "static/media/survey-icon-developer.2806fbdf46e988776bf2867f13ba6448.svg";
export { ForwardRef as ReactComponent };